import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { houseNav, opsNav, adminNav, isActivePath } from "@/components/layout/nav";
import { useApprovals } from "@/components/mh/hooks";

const MAIN = ["/", "/ai-team", "/map", "/approvals"];
const mainTabs = houseNav.filter((t) => MAIN.includes(t.path));
const moreTabs = [...houseNav.filter((t) => !MAIN.includes(t.path)), ...adminNav, ...opsNav];
const short = { Overview: "Home", "AI Team": "Team", Constellation: "Map", Approvals: "Desk" };

export default function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const { pathname } = useLocation();
  const { items } = useApprovals();
  const isMoreActive = moreTabs.some((t) => isActivePath(pathname, t.path));
  const tabCls = (active) => cn("relative flex flex-col items-center justify-center gap-0.5 min-w-[56px] min-h-[44px] transition-colors", active ? "text-[#D4FF3A]" : "text-muted-foreground");

  return (
    <nav className="fixed bottom-0 inset-x-0 lg:hidden z-50 bg-[#050508]/95 backdrop-blur-xl border-t border-white/[0.07]" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
        {mainTabs.map(({ path, label, icon: Icon, badge }) => (
          <NavLink key={path} to={path} className={tabCls(isActivePath(pathname, path))} data-testid={`btm-${short[label].toLowerCase()}`}>
            <Icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-[10px] font-mono tracking-wider">{short[label]}</span>
            {badge && items.length > 0 && <span className="absolute top-0 right-2 font-mono text-[9px] rounded-full bg-[#FFB020] text-black px-1">{items.length}</span>}
          </NavLink>
        ))}
        <Popover open={moreOpen} onOpenChange={setMoreOpen}>
          <PopoverTrigger asChild>
            <button className={tabCls(isMoreActive)} data-testid="btm-more">
              <MoreHorizontal className="w-5 h-5" strokeWidth={1.5} />
              <span className="text-[10px] font-mono tracking-wider">More</span>
            </button>
          </PopoverTrigger>
          <PopoverContent side="top" align="end" className="w-56 p-2 bg-[#0A0A0F] border-white/10">
            {moreTabs.map(({ path, label, icon: Icon }) => (
              <NavLink key={path} to={path} onClick={() => setMoreOpen(false)} data-testid={`more-${label.toLowerCase().replace(/\s/g, "-")}`}
                className={cn("flex items-center gap-3 px-3 py-3 rounded-md text-sm transition-colors min-h-[44px]", isActivePath(pathname, path) ? "bg-white/[0.07] text-foreground" : "text-muted-foreground hover:text-foreground hover:bg-white/5")}>
                <Icon className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
                <span className="text-sm">{label}</span>
              </NavLink>
            ))}
          </PopoverContent>
        </Popover>
      </div>
    </nav>
  );
}
